import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { BuyerPaymentObligations } from '../../../../models/FlowOfFunds/buyer-payment-obligations.model';

/** Cross-engagement — every payment the calling buyer owes, all engagements. */
export const GetBuyerPaymentObligations = createAsyncThunk(
    'flowOfFunds/getBuyerPaymentObligations',
    async (_: void, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.get('/api/FlowOfFunds/buyer-obligations');

            if (response.status !== 200) {
                throw new Error('Failed to fetch buyer payment obligations');
            }

            return response.data as BuyerPaymentObligations;
        } catch (error) {
            createNotification(
                'There was an error while loading your post-closing payments.',
                'error'
            );
            throw error;
        }
    }
);
